<div *ngIf="cs.isBrowser" class="modal-content modal-theme2 modal-subscription-body subscription-unlock-modal">
  <ng-container *ngIf="!showSubscriptionDetail">
    <div class="modal-header custom-subscribe-header">
      <h4 id="dialog-sizes-name2" class="modal-title text-inherit">
        {{data?.showSubscriptionsForcefully ? SubscriptionsConstant.Subscription_Required : SubscriptionsConstant.To_unlock_content_please_choose_options_below}}
      </h4>
      <em *ngIf="data?.showSubscriptionsForcefully" class="icon-litesubscribe"></em>
    </div>
    <div class="modal-body modal-postprice">
      <div
        *ngIf="data?.is_subscription && data?.is_individual_price && !data?.showSubscriptionsForcefully"
        class="postprice-head"
      >
        <label class="custom-checkbox custom-radio-lg">
          Subscription
          <input
            [(ngModel)]="popupObj.optionType"
            [ngModelOptions]="{ standalone: true }"
            [value]="1"
            type="radio"
            name="avail-opt"
          />
          <span [ngClass]="{'icon-liteicon-black-tick': popupObj.optionType === 1 }" class="checkmark"></span>
        </label>
      </div>
      <div class="postprice-content" *ngIf="data?.showSubscriptionsForcefully">
        <h5>{{data?.first_name}} {{data?.last_name}} {{SubscriptionsConstant.only_accepts_Direct_Message_from_Subscribers}}</h5>
      </div>
      <div
        *ngIf="
          (data?.is_subscription && !data?.is_individual_price) ||
          (data?.is_subscription &&
            data?.is_individual_price &&
            popupObj.optionType === 1) ||
          data?.showSubscriptionsForcefully
        "
        class="postprice-content"
        [ngClass]="{'mt-4': data?.showSubscriptionsForcefully}"
      >
        <h5>Select Subscription Options:</h5>
        <div class="postprice-radio postprice-checkbox">
          <label
            *ngFor="let item of data?.subscription"
            class="custom-checkbox custom-radio-lg"
          >
            {{ item.title || item?.name }}
            <input
              [(ngModel)]="popupObj.selectedSubscription"
              [ngModelOptions]="{ standalone: true }"
              [value]="item.sk"
              (change)="selectSubscription(item, $event)"
              type="radio"
              name="subs-option"
            />
						<span [ngClass]="{'icon-liteicon-black-tick': popupObj?.selectedSubscription === item?.sk }" class="checkmark"></span>
          </label>
        </div>
      </div>
      <div
        *ngIf="
          data?.is_subscription &&
            data?.is_subscription &&
            data?.is_individual_price &&
            popupObj.optionType === 2 &&
          !data?.showSubscriptionsForcefully
        "
        class="individualprice-content"
      >
        <div class="row">
          <div class="col-12 col-lg-12">
            <div class="form-group">
              <label>Individual Price</label>
              <span class="dollarSign">$</span>
              <input
                [(ngModel)]="popupObj.indPriceValue"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                placeholder
                class="form-control"
                readonly
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button (click)="cancelModal()" class="btn btn-default">Cancel</button>
      <button (click)="select()" class="btn btn-primary">
        {{ data?.showSubscriptionsForcefully ? SubscriptionsConstant.Select : SubscriptionsConstant.Learn_More_About_This_Plan}}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="showSubscriptionDetail">
    <div class="modal-body">
      <div class="profile-card">
        <div class="profile-card-banner">
          <img
            appMobileOptimization
            [originalUrl]="currSelectedSubscription?.user_details?.banner_image_url"
            *ngIf="currSelectedSubscription?.user_details?.banner_image_url"
            appDisableRightClick
            [src]="currSelectedSubscription?.user_details?.banner_image_url"
            [format]="'webp'"
            alt="Banner"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div class="profile-card-content">
          <div class="profile-card-user">
            <div class="profileImage">
              <img
                *ngIf="
                  currSelectedSubscription?.user_details?.profile_image_url
                "
                appDisableRightClick [src]="
                  currSelectedSubscription?.user_details?.profile_image_url
                "
                alt
              />
            </div>
            <div class="profile-card-info">
              <h3>
                {{ currSelectedSubscription?.user_details?.first_name }}
                {{ currSelectedSubscription?.user_details?.last_name }}
              </h3>
              <p>
                {{ currSelectedSubscription?.user_details?.general_location }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-subscribe-get">
        <p>{{ currSelectedSubscription?.name }} Benefits:</p>
        <div class="scroll-event">
          <ul>
            <li *ngFor="let feature of currSelectedSubscription?.features">
              <span>{{ feature }}</span>
            </li>
            <div *ngIf="currSelectedSubscription?.free_dms_count">
              <div class="free-dms-badge">
                <em class="icon-litefree-dms-count"></em>
                <div class="free-dms-text">
                  <div class="free-dms-primary">
                    <ng-container *ngIf="currSelectedSubscription?.is_unlimited_free_dms; else finiteDms">
                      {{ Application.FREE_DIRECT_MESSAGES_PER_MONTH.replace('[quantity]', Application.UNLIMITED) }}
                    </ng-container>
                    <ng-template #finiteDms>
                      {{ Application.FREE_DIRECT_MESSAGES_PER_MONTH.replace('[quantity]', currSelectedSubscription?.free_dms_count) }}
                    </ng-template>
                  </div>
                  <div *ngIf="!currSelectedSubscription?.is_unlimited_free_dms && currSelectedSubscription?.user_details?.price_for_dm > 0" class="free-dms-secondary">
                    {{ 
                      Application.REGULAR_PRICE_FOR_MESSAGE.replace('[price]', (currSelectedSubscription?.user_details?.price_for_dm | currency))
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ul>
          <div class="modal-susbcribeDuration">
            <p>Select Duration</p>
            <div class="modal-susbcribeList">
              <ng-container
                *ngFor="let plan of currSelectedSubscription?.plan_details"
              >
                <label>
                  <input
                    [checked]="plan.duration === selectedSubsPackage.duration"
                    (click)="selectPlan(plan)"
                    type="radio"
                    name="subscription-package"
                  />
                  <span class="active">
                    {{
                      plan?.duration === 1
                        ? '1 Month'
                        : plan?.duration + ' Months'
                    }}
                  </span>
                </label>
              </ng-container>
            </div>
          </div>
          <div class="modal-subscribePrice">
            <p>
              Price for
              {{
                selectedSubsPackage?.duration === 1
                  ? '1 Month'
                  : selectedSubsPackage?.duration + ' Months'
              }}
            </p>
            <h5>
              ${{
                selectedSubsPackage?.price
                  | priceDiscount: selectedSubsPackage?.discount
              }}
              <span
                *ngIf="
                  selectedSubsPackage?.discount &&
                  selectedSubsPackage?.discount !== '0'
                "
              >
                &nbsp;({{ selectedSubsPackage?.discount }}% off Monthly Price)
              </span>
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            (click)="showSubscriptionDetail = false"
            class="btn btn-default"
          >
            Cancel
          </button>
          <button
            [disabled]="selectedSubsPackage?.is_subscribed"
            (click)="goToPaymentForSubscription(selectedSubsPackage)"
            class="btn btn-primary"
          >
              {{ selectedSubsPackage?.is_subscribed 
                  ? Fields.SUBSCRIBED 
                  : (selectedSubsPackage?.trial_enable && selectedSubsPackage?.trial_days > 0) 
                      ? Fields.START + ' ' + selectedSubsPackage?.trial_days + '-' + Fields.DAY + ' ' + Fields.FREE_TRIAL 
                      : Fields.SELECT 
              }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
